// extracted by mini-css-extract-plugin
module.exports = {"container":"_U8w1H0Ow","content":"_1eWLuFMH","iconContainer":"_lfVVEJKh","title":"_FMcQ1eqC","description":"_u9YrL10t","step":"_OWXFv8_6","headingContent":"_xIHih789"};